<script>
  import { onMount } from "svelte";
  import { get } from "svelte/store";
  import profileStore from "@/stores/profile";
  import SvgWrapper from "@/components/atoms/SvgWrapper.svelte";
  import SvgHamBurger from "$assets/svg/navigation-ham-burger.svg?src";
  import InstallBanner from "./InstallBanner.svelte";
  import RechargeButton from "../atoms/RechargeButton.svelte";
  import * as PropTypes from "prop-types";
  import ImageUrls from "@/constants/ImageUrls";

  const { checkPropTypes, func } = PropTypes;
  export let setSideBar;

  const propTypes = {
    setSideBar: func,
  };

  const profileState = get(profileStore);
  const showRechargeCta = profileState?.showRechargeCta;

  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "NavBar");
  });

  const handleHamBurgerClick = () => {
    setSideBar(true);
  };
</script>

<div
  class="w-full absolute top-0 left-0 z-[3] bg-nav-overlay"
  data-testid="navbar"
>
  <div
    class="py-md pl-md cursor-pointer flex justify-between items-center"
    on:click={handleHamBurgerClick}
    data-testid="hamburger-menu"
  >
    <div class="flex wrapper">
      <SvgWrapper className="h-lmg w-lmg text-white" svg={SvgHamBurger} />
      <img
        src={ImageUrls.MOJ_LOGO}
        srcset={`${ImageUrls.MOJ_LOGO} 1x, ${ImageUrls.MOJ_LOGO_2X} 2x`}
        alt="Moj"
        width="46"
        height="26"
      />
    </div>
    <div class="flex">
      {#if showRechargeCta}
        <RechargeButton />
      {/if}
      <InstallBanner isVideoFeed={true} source="trending_feed" />
    </div>
  </div>
</div>

<style>
  .wrapper {
    gap: 19px;
  }
</style>
